import { useEffect, useState } from "react"
import { SwitchIcon } from "../../../../ui/icons/SwitchIcon"
import { Calendar } from "../../../../ui/molecules/calendar"
import { formatterDate, optionsFormatter, ParcelMethodOptions } from "../../../../utils"
import { SelectCustom } from "../../../../ui/molecules/select"
import Input from "../../../../ui/molecules/input"
import Button from "../../../../ui/molecules/button"
import { SaveIcon } from "../../../../ui/icons/SaveIcon"
import { ListIcon } from "../../../../ui/icons/ListIcon"
import { PopupForm } from "../../../../ui/organisms/popupForm"
import { ParticelleMacrousePopup, Superficie } from "./popup/macrouse"
import { PrinterIcon } from "../../../../ui/icons/PrinterIcon"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { GetAllParcels, GetMacrouseNot, ParcelsBulkUpdate, resetGetAllParcelsStatus, resetGetMacrouse, resetParcelsBulkUpdateStatus, setOnEdit, setParcelsBulkUpdateDTO, setParcelUpdateConversionEndingDatePerIndex, setParcelUpdateConversionStartingDatePerIndex, setParcelUpdateMethodPerIndex, setParcelUpdateNotePerIndex } from "./slice"
import { LogoSpinnerComponent } from "../../../../lib/spinner/spinnerLogo"
import { ParcelUpdateDTO } from "./dataservice/dto"
import { IdentificationBoardProcessingNotification } from "../preparazione/slice"

export function ParticelleList() {
    const dispatch = useAppDispatch()
    const parcelState = useAppSelector(state => state.parcel)
    const notificationState = useAppSelector(state => state.notification)
    const [showPopup, setShowPopup] = useState<boolean>(false)

    useEffect(() => {
        if(parcelState.parcelsMacrouseDetailsStatus === 'successfully') {
            setShowPopup(true)
            dispatch(resetGetMacrouse())
        }
    }, [parcelState.parcelsMacrouseDetailsStatus])

    const computeSurfaceByMacrouse = (): Map<string, Superficie> => {
        const result = new Map<string, Superficie>()

        parcelState.parcelsMacrouseDetails?.parcelsByMacrouse.forEach(p => {
            const key = p.macrouseIdentifier
            const existing = result.get(key)

            const newValues = {
                bio: Number(p.bioArea) || 0,
                conversion: Number(p.inConversioneArea) || 0,
                convz: Number(p.convenzionaleArea) || 0,
                tare: Number(p.convenzionaleArea) || 0
            }

            if (existing) {
                result.set(key, {
                    bio: existing.bio + newValues.bio,
                    conversion: existing.conversion + newValues.conversion,
                    convz: existing.convz + newValues.convz,
                    tare: existing.tare + newValues.tare
                })
            } else {
                result.set(key, newValues)
            }
        })

        return result
    }


    useEffect(() => {
        dispatch(GetAllParcels({
            ...parcelState.getAllParcelsFilters,
            notificationId: notificationState.notificationIdToUpdate
        }))
    }, [])

    useEffect(() => {
        if (parcelState.getAllParcelsStatus === 'successfully' &&
            parcelState.getAllParcelsResponse !== undefined
        ) {
            dispatch(resetGetAllParcelsStatus())

            const data = parcelState.getAllParcelsResponse.data.map(p => {
                return {
                    conversionStartingDate: p.conversionStartingDate,
                    conversionEndingDate: p.conversionEndingDate,
                    method: p.method,
                    note: p.note,
                    parcelId: p.id
                } as ParcelUpdateDTO
            })

            dispatch(setParcelsBulkUpdateDTO(data))
        }
    }, [parcelState.getAllParcelsStatus])

    useEffect(() => {
        if (parcelState.updateParcelsFromCsvStatus === 'successfully') {
            dispatch(GetAllParcels({
                ...parcelState.getAllParcelsFilters,
                notificationId: notificationState.notificationIdToUpdate
            }))
        }
    }, [parcelState.updateParcelsFromCsvStatus])

    useEffect(() => {
        if (parcelState.parcelsBulkUpdateStatus === 'successfully') {
            dispatch(resetParcelsBulkUpdateStatus())
            dispatch(GetAllParcels({
                ...parcelState.getAllParcelsFilters,
                notificationId: notificationState.notificationIdToUpdate
            }))
            dispatch(setOnEdit(false))
        }
    }, [parcelState.parcelsBulkUpdateStatus])

    if (parcelState.getAllParcelsStatus === 'loading') {
        return (
            <LogoSpinnerComponent fullScreen />
        )
    }

    return (
        <div>
            <div className="mt-5 mb-5" style={{ display: 'flex', gap: '18px', justifyContent: 'flex-end' }}>
                <Button
                    color="dimgrey"
                    variant="outline"
                    iconPosition="left"
                    icon={<SwitchIcon color="#74A4A9" />}
                    size="md"
                    label="Abilita modifica"
                    onClick={() => dispatch(setOnEdit(!parcelState.onEdit))}
                />

                <Button
                    disabled={!parcelState.onEdit}
                    color="dimgrey"
                    variant="solid"
                    iconPosition="left"
                    icon={<SaveIcon color="#74A4A9" />}
                    size="md"
                    label="Salva campi"
                    onClick={() => dispatch(ParcelsBulkUpdate(parcelState.parcelsBulkUpdateRequest))}
                />

                <Button
                    color="orange"
                    variant="solid"
                    iconPosition="left"
                    icon={<PrinterIcon color="#fff" />}
                    size="md"
                    label="Scheda ident."
                    onClick={() => { 
                        dispatch(IdentificationBoardProcessingNotification(notificationState.notificationIdToUpdate))
                    }}
                />

                <Button
                    color="orange"
                    variant="solid"
                    iconPosition="left"
                    icon={<ListIcon colors="#fff" />}
                    size="md"
                    label="Riepilogo Macrouso"
                    onClick={
                        () => //setShowPopup(true)
                        dispatch(GetMacrouseNot(notificationState.notificationIdToUpdate))
                        }
                />
            </div>

            <table id="users-table" className="w-[100%] particle-table">
                <thead className="h-[40px] uppercase">
                    <tr>
                        <th style={{ borderTopLeftRadius: '8px' }}></th>
                        <th className="width-[130px]">UP</th>
                        <th className="width-[130px]">Belfiore</th>
                        <th className="width-[100px]">Sez</th>
                        <th className="width-[130px]">Sub</th>
                        <th className="width-[130px]">Foglio</th>
                        <th className="width-[130px]">Part.</th>
                        <th className="width-[130px]">Titolo P.</th>
                        <th className="width-[130px]">Sup. Tot.</th>
                        <th className="width-[130px]">Sup. Bio.</th>
                        <th className="width-[130px]">Sup. Convz.</th>
                        <th className="width-[130px]">App.</th>
                        <th className="width-[130px]">Macrouso</th>
                        <th className="width-[130px]">Cod. Prod.</th>
                        <th className="width-[100px]">Data Prima Notifica</th>
                        <th style={{ maxWidth: '150px' }}>Data Inizio Conversione</th>
                        <th style={{ maxWidth: '150px' }}>Data Fine Conversione</th>
                        <th className="width-[130px]">Metodo</th>
                        <th className="width-[130px]">Note</th>
                        <th style={{ borderTopRightRadius: '8px', width: '40px' }}></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        parcelState.getAllParcelsResponse?.data.map((p, index) =>
                            <tr
                                key={index}
                                style={{
                                    color: '#4D797F',
                                    background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                                }}
                            >
                                <td></td>
                                <td>{p.productiveUnitNumber}</td>
                                <td>{p.cadastralCode}</td>
                                <td>{p.section}</td>
                                <td>{p.sub}</td>
                                <td>{p.sheet}</td>
                                <td>{p.parcel}</td>
                                <td>{p.ownership}</td>
                                <td>{p.totalArea}</td>
                                <td>{p.bioArea}</td>
                                <td>{p.conventionalArea}</td>
                                <td>{p.app}</td>
                                <td>{p.macrouseIdentifier}</td>
                                <td>{`${p.speciesIdentifier} - ${p.varietyIdentifier}`}</td>
                                <td>{formatterDate(p.firstNotificationDate)}</td>
                                <td >{parcelState.onEdit ?
                                    <Calendar
                                        selected={parcelState.parcelsBulkUpdateRequest.parcelsBulkUpdateDTO[index].conversionStartingDate}
                                        onChange={(date) => dispatch(setParcelUpdateConversionStartingDatePerIndex({ data: date, index: index }))}
                                        onClear={(date) => dispatch(setParcelUpdateConversionStartingDatePerIndex({ data: date, index: index }))}
                                        reducedHeight
                                    /> :
                                    <span>{formatterDate(p.conversionStartingDate)}</span>
                                }</td>
                                <td >{parcelState.onEdit ?
                                    <Calendar
                                        selected={parcelState.parcelsBulkUpdateRequest.parcelsBulkUpdateDTO[index].conversionEndingDate}
                                        onChange={(date) => dispatch(setParcelUpdateConversionEndingDatePerIndex({ data: date, index: index }))}
                                        onClear={(date) => dispatch(setParcelUpdateConversionEndingDatePerIndex({ data: date, index: index }))}
                                        reducedHeight
                                    /> :
                                    <span>{formatterDate(p.conversionEndingDate)}</span>
                                }</td>
                                <td style={{ width: parcelState.onEdit ? '200px' : 'auto' }}>{parcelState.onEdit ?
                                    <SelectCustom
                                        value={parcelState.parcelsBulkUpdateRequest.parcelsBulkUpdateDTO[index].method}
                                        reducedHeight
                                        placeholder=""
                                        onChange={(value) => dispatch(setParcelUpdateMethodPerIndex({ data: value, index: index }))}
                                        options={ParcelMethodOptions}
                                    /> :
                                    <span>{optionsFormatter(p.method, ParcelMethodOptions)}</span>
                                }</td>
                                <td style={{ width: parcelState.onEdit ? '300px' : 'auto' }}>{parcelState.onEdit ?
                                    <div className="mt-2">
                                        <Input
                                            value={parcelState.parcelsBulkUpdateRequest.parcelsBulkUpdateDTO[index].note}
                                            onChangeText={(text) => dispatch(setParcelUpdateNotePerIndex({ data: text, index: index }))}
                                        />
                                    </div> :
                                    <span>{p.note}</span>
                                }</td>
                                <td></td>
                            </tr>
                        )}
                </tbody>
            </table>
            {
                (showPopup) && (
                    <PopupForm headerGreen title="Riepilogo per Macrouso" close={() => setShowPopup(false)}>
                        <ParticelleMacrousePopup valuesArray={parcelState.parcelsMacrouseDetails!} close={() => setShowPopup(false)} />
                    </PopupForm>
                )
            }
        </div>
    )
}